import type { ComponentType } from 'react';
import type { NewKind } from '../../concepts/types';
import type { GameProps } from '../kit/shell';
import LabelParts from './LabelParts';
import FindPart, { FindInScene } from './FindPart';
import PlaceIt from './PlaceIt';
import SortBins from './SortBins';
import YesNo from './YesNo';
import OddOneOut from './OddOneOut';
import FindAll from './FindAll';
import MemoryPairs from './MemoryPairs';
import SlotOrder from './SlotOrder';
import PictureSentence from './PictureSentence';
import BlockCopy from './BlockCopy';
import TaskChain from './TaskChain';
import WaitForGo from './WaitForGo';
import RotateFind from './RotateFind';
import StudioGame from './StudioGame';
import TraceIt from './TraceIt';

export const PLAYERS: Record<NewKind, ComponentType<GameProps>> = {
  labelParts: LabelParts,
  findPart: FindPart,
  findInScene: FindInScene,
  placeIt: PlaceIt,
  sortBins: SortBins,
  yesNo: YesNo,
  oddOneOut: OddOneOut,
  findAll: FindAll,
  memoryPairs: MemoryPairs,
  slotOrder: SlotOrder,
  pictureSentence: PictureSentence,
  blockCopy: BlockCopy,
  taskChain: TaskChain,
  waitForGo: WaitForGo,
  rotateFind: RotateFind,
  studio: StudioGame,
  traceIt: TraceIt,
};
